import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import logo from '../../assets/img/barLogo.png';

export const MobileMenu = ({ options }) => {

    const [open, setOpen] = useState(false);

    return (
        <div className="flex justify-between items-center">
            <button className="md:hidden" onClick={() => setOpen(true)}>
                <Menu className="w-6 h-6 ml-8 mt-2" />
            </button>
            {open && (
                <div className="fixed inset-0 z-50 bg-white w-full h-full p-4">
                    <div className="flex justify-end">
                        <button onClick={() => setOpen(false)}>
                            <X className="w-6 h-6 t-4 text-black" />
                        </button>
                    </div>
                    <div className="pt-6 flex flex-col justify-center items-start mt-4">
                        <div className="absolute left-4 top-4">
                            <img src={logo} alt="" />
                        </div>
                        {options.map((item, index) => (
                            <div className="pb-4">
                                <Link
                                    key={index}
                                    to={item.link}
                                    className="flex items-center text-xl"
                                    onClick={() => setOpen(false)}
                                >
                                    <div className="pr-2">
                                        {item.img}
                                    </div>
                                    <div>
                                        {item.nav}
                                    </div>

                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};